import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE, DOWNLOAD_EXCEL } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// ChildCategory - Get All (Read)
export const GetAllOrder = createAsyncThunk(
  "masters/order/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.OrderManage.Order}?name=${
          filter?.name || ""
        }&sortOrder=${filter?.sortOrder || ""}&searchOrderStatus=${filter?.searchOrderStatus || ""}&childcategory_id=${filter?.childcategory_id || ""}&subcategory_id=${filter?.subcategory_id || ""}&category_id=${
          filter?.category_id || ""
        }&page=${filter?.page || IDS.PAGE}&per_page=${
          filter?.perPage || IDS.PERPAGE
        }`
      );
      
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// ChildCategory - Get (Read)
export const GetSingleDataProduct = createAsyncThunk(
  "masters/childcategory/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.ProductManage.Product}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// ChildCategory - Create (Add)
export const AddDataProduct = createAsyncThunk(
  "masters/product/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.ProductManage.Product, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const BulkProduct = createAsyncThunk(
  "masters/product/bulk",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.ProductManage.Product}/bulk`, data);
      if(res?.success){
        return res;
      }else{
      
        return rejectWithValue(res);
      }
    } catch (error) {
     
      
      return rejectWithValue(error.response.data);
    }
  }
);

export const ProductSample = createAsyncThunk(
  "masters/product/sample",
  async (data, { rejectWithValue }) => {
    try {
      const res = await DOWNLOAD_EXCEL(`${APIS.ProductManage.Product}/sample`, {},"Product");
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// ChildCategory - Update
export const UpdateDataProduct = createAsyncThunk(
  "masters/childcategory/update",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.ProductManage.Product}/${id}`, formData);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// {
//     name: data.name,
//     country_id: data.country_id,
//     state_id: data.state_id
// }

// ChildCategory - Delete
export const DeleteDataProduct = createAsyncThunk(
  "masters/childcategory/delete",
  async (id, { rejectWithValue }) => {
    try {
      await DELETE(`${APIS.ProductManage.Product}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// ChildCategory - Status
export const StatusProduct = createAsyncThunk(
  "masters/childcategory/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.ProductManage.Product}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const accountantPayment = createAsyncThunk(
  "/order/payment",
  async ({data,id}, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.OrderManage.PaymentProof}/${id}`, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const AssignDesigner = createAsyncThunk(
  "/order/assign-designer",
  async ({data,id}, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.OrderManage.AssignDesigner}/${id}`, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const PrintingCount = createAsyncThunk(
  "/order/printing-count",
  async ({data,id}, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.OrderManage.PrintingCount}/${id}`, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const DesignerNote= createAsyncThunk(
  "/order/designer-note",
  async ({data,id}, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.OrderManage.DesignerNote}/${id}`, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const OrderStatusUpdate = createAsyncThunk(
  "/order/status",
  async ({data,id}, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.OrderManage.OrderStatus}/${id}`, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const QCComment = createAsyncThunk(
  "/order/qc",
  async ({data,id}, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.OrderManage.QCComment}/${id}`, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "order",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllOrder.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllOrder.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllOrder.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingleDataProduct.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingleDataProduct.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingleDataProduct.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(AddDataProduct
        .fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(AddDataProduct
        .rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(UpdateDataProduct
        .pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UpdateDataProduct
        .fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        const index = state.data.findIndex(
          (childcategory) => childcategory.id === action.payload?.data?.id
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(UpdateDataProduct
        .rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(DeleteDataProduct
        .pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(DeleteDataProduct
        .fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = state.data.filter(
          (childcategory) => childcategory.id !== action.payload
        );
      })
      .addCase(DeleteDataProduct
        .rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(StatusProduct
        .pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusProduct
        .fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(StatusProduct
        .rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(BulkProduct
        .fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(BulkProduct
        .rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      .addCase(BulkProduct
        .pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(ProductSample
        .pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(ProductSample
        .fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(ProductSample
        .rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(accountantPayment
        .fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(accountantPayment
        .rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(accountantPayment
        .pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(OrderStatusUpdate
        .fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(OrderStatusUpdate
        .rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(OrderStatusUpdate
        .pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

       .addCase(AssignDesigner
        .fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(AssignDesigner
        .rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AssignDesigner
        .pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

       .addCase(PrintingCount
        .fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(PrintingCount
        .rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(PrintingCount
        .pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      .addCase(QCComment
        .fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(QCComment
        .rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(QCComment
        .pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

       .addCase(DesignerNote
        .fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data.unshift(action.payload.data);
      })
      .addCase(DesignerNote
        .rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(DesignerNote
        .pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })

      
  },
});

export default Slice.reducer;
